/**
 * Единый источник названия продукта.
 *
 * Бренд пишется слитно и с заглавными POS: `POSPoint`. Домен (`pospoint.ru`)
 * в интерфейсе не выводим — он для сайта, издателя и release notes.
 * Версия подставляется сборкой (`__APP_VERSION__`), чтобы не расходиться
 * с `package.json`.
 */

export const APP_NAME = 'POSPoint'
export const APP_DOMAIN = 'pospoint.ru'
export const APP_URL = `https://${APP_DOMAIN}`
export const APP_TAGLINE = 'Касса нового поколения'
/** Заголовок вкладки и PWA. */
export const APP_TITLE = `${APP_NAME} — касса`

export const APP_VERSION = import.meta.env?.VITE_APP_VERSION ?? '0.0.0-dev'
